import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import moment from 'moment';
import { isMobile } from 'react-device-detect';

const styles = theme => ({
  messageContainer: {
    position: 'fixed',
    bottom: '20px',
    left: '50%',
    transform: 'translateX(-50%)',
    width: isMobile ? '100%' : '545px',
    height: isMobile ? 'auto' : '98px',
    backgroundColor: '#DFEAFF',
    border: 'solid 1px #81B1FF',
    borderRadius: '12px',
    padding: isMobile ? '20px' : '12px 20px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    zIndex: 1000
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    borderLeft: '2px solid #0133A0',
  },
  closeButton: {
    position: 'absolute',
    right: 0,
    top: 0,
    padding: '4px',
    color: '#0033A0',
    '&:hover': {
      backgroundColor: 'rgba(0, 51, 160, 0.1)'
    }
  },
  checkIcon: {
    color: '#0033A0',
    marginRight: '8px',
    marginLeft: '8px',
    width: '20px',
    height: '20px'
  },
  title: {
    color: '#0033A0 !important',
    fontSize: '16px !important',
    fontWeight: 600,
    fontFamily: 'Sura Sans !important',
    margin: 0,
    lineHeight: '24px !important',
  },
  message: {
    color: '#0033A0 !important',
    fontSize: '16px',
    fontWeight: 600,
    fontFamily: 'Sura Sans',
    margin: 0,
    textAlign: 'left',
    lineHeight: '22px',
    paddingLeft: '38px',
  }
});

const formatDate = (date, format = 'DD/MM/YYYY') => {
  if (!date || date === 'null') return null;
  return moment.utc(parseInt(date) * 1000).format(format);
};

const MessageSuccessDomiciliation = ({ classes, onClose, receiptNumber, nextDate }) => {
  return (
    <div className={classes.messageContainer}>
      <div className={classes.titleContainer}>
        <CheckCircleOutlineIcon className={classes.checkIcon} />
        <h3 className={classes.title}>La domiciliación ha sido programada con éxito.</h3>
        <IconButton 
          className={classes.closeButton}
          size="small"
          onClick={onClose}
          aria-label="close"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </div>
      <p className={classes.message}>
        Los siguientes cobros serán realizados de manera automática.
      </p>
    </div>
  );
};

export default withStyles(styles)(MessageSuccessDomiciliation); 


// WEBPACK FOOTER //
// ./src/containers/agent/Tabs/Payments/MessageSuccessDomiciliation.js